import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgSleutels = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <g clipPath="url(#Sleutels_svg__a)">
      <mask
        id="Sleutels_svg__b"
        width={21}
        height={22}
        x={5}
        y={16}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M24.15 17.88a6 6 0 0 0-9.65 6.83l-8.73 8.72L10 37.68l2.83-2.83-1.41-1.42 5.89-5.89a6 6 0 0 0 6.83-9.66zm-2.82 5.65a2 2 0 1 1-2.836-2.82 2 2 0 0 1 2.836 2.82"
        />
      </mask>
      <g mask="url(#Sleutels_svg__b)">
        <path
          fill="#FED27A"
          d="m6.76 47.44-12.24-7.07 7.07-12.25zM26.08 42.26l-12.24-7.07 7.07-12.25z"
        />
        <path
          fill="#FED27A"
          d="m1.59 28.12 12.25 7.07-7.08 12.25z"
        />
        <path
          fill="#FED27A"
          d="m6.76 47.44 7.08-12.25 12.24 7.07zM20.91 22.94l-7.07 12.25-12.25-7.07z"
        />
        <path
          fill="#FED27A"
          d="m-3.59 8.8 12.25 7.07-7.07 12.25zM20.91 22.94 8.66 15.87l7.07-12.24zM1.59 28.12l7.07-12.25 12.25 7.07z"
        />
        <path
          fill="#F7A941"
          d="m20.91 22.94 12.24 7.08-7.07 12.24z"
        />
        <path
          fill="#FED27A"
          d="m40.23 17.77-7.08 12.25-12.24-7.08z"
        />
        <path
          fill="#FED27A"
          d="m15.73 3.63 12.25 7.07-7.07 12.24z"
        />
        <path
          fill="#F7A941"
          d="m20.91 22.94 7.07-12.24 12.25 7.07z"
        />
      </g>
      <mask
        id="Sleutels_svg__c"
        width={25}
        height={17}
        x={10}
        y={2}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M22.63 8.38a6 6 0 1 0-1.37 3.76L29.1 15l-.68 1.88 3.76 1.37 2-5.64zM18.51 9a2 2 0 1 1-3.76-1.365A2 2 0 0 1 18.51 9"
        />
      </mask>
      <g mask="url(#Sleutels_svg__c)">
        <path
          fill="#F7A941"
          d="M22.01 27.61 9.76 20.54l7.07-12.25z"
        />
        <path
          fill="#F18700"
          d="M16.83 8.29 9.76 20.54l-12.24-7.07z"
        />
        <path
          fill="#F7A941"
          d="m41.33 22.44-12.25-7.07 7.07-12.25z"
        />
        <path
          fill="#F18700"
          d="m16.83 8.29 12.25 7.08-7.07 12.24zM22.01 27.61l7.07-12.24 12.25 7.07z"
        />
        <path
          fill="#F7A941"
          d="m36.15 3.12-7.07 12.25-12.25-7.08z"
        />
        <path
          fill="#F18700"
          d="m11.66-11.02 12.25 7.07-7.08 12.24zM36.15 3.12 23.91-3.95l7.07-12.25z"
        />
        <path
          fill="#F7A941"
          d="m16.83 8.29 7.08-12.24 12.24 7.07zM16.83 8.29 4.59 1.22l7.07-12.24z"
        />
        <path
          fill="#F18700"
          d="M-2.48 13.47 4.59 1.22l12.24 7.07zM30.98-16.2l12.24 7.07-7.07 12.25z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="Sleutels_svg__a">
        <path
          fill="#fff"
          d="M0 0h40v40H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgSleutels);

export default ForwardRef;
